export default __webpack_public_path__ + "static/media/mobile-single-image.17b9a5e4.jpg";